import { PlusCircleOutlined } from '@ant-design/icons'
import { Button, ButtonProps } from 'antd'
import React, { FunctionComponent, memo } from 'react'

export interface AuctionMonitoringLinkedPropertyModalButtonTriggerProps {
  propertyCount?: number
  buttonProps?: ButtonProps
  shortAssignTtitle?: boolean
  toggleModal: () => void
}

export const AuctionMonitoringLinkedPropertyModalButtonTrigger: FunctionComponent<AuctionMonitoringLinkedPropertyModalButtonTriggerProps> =
  memo(({ propertyCount, buttonProps, shortAssignTtitle, toggleModal }) => {
    if (propertyCount) {
      return (
        <Button
          type="link"
          className="!px-0"
          size="small"
          title="Zobrazit přiřazené nemovitosti k dražbě"
          onClick={toggleModal}
          {...buttonProps}
        >
          ({propertyCount}) - zobrazit
        </Button>
      )
    }

    return (
      <Button
        type="link"
        icon={
          <PlusCircleOutlined className={shortAssignTtitle ? '!text-xs' : ''} />
        }
        className="!pl-0"
        size="small"
        title="Přiřadit konkrétní nemovitost k dražbě"
        onClick={toggleModal}
        {...buttonProps}
      >
        {!shortAssignTtitle && 'Přiřadit nemovitost'}
      </Button>
    )
  })
